import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'query'
})
export class QueryPipe implements PipeTransform {
    transform(values: Array<Object>, query: string): any {
        if (query) {
            return values.filter((value) => {
                return Object.values(value).some((field) => {
                    if (field) {
                        return field.toString().toLowerCase().includes(query.toLowerCase());
                    } else {
                        return false;
                    }
                });
            });
        } else {
            return values;
        }
    };
}
